import { swRequest } from "@sourcewhale/shared/src/svelte/api/sw-request";

export const sendWhatsApp = (body) =>
  swRequest({
    path: "/api/whatsapp/send",
    method: "POST",
    body,
  });
